// extracted by mini-css-extract-plugin
export default {"willingness":"willingness_willingness__fXepX","selected":"willingness_selected__d6Cof","bottom":"willingness_bottom__DZXT3"};